
import { Box, Typography } from "@mui/material";
import './products.css';

import BannerCarousel from '../../../components/Carousel/banner-carousel';

const BannerData = [
  {
    customClass: 'banner-classic',
    title: 'Clásico',
    description: 'Los clásicos nunca pasan de moda… en el cine, en la música y por supuesto, en las galletas. Comparte el sabor de siempre con nuestro surtido Clásico Marián®, el favorito de todas las reuniones y el consentido de la mesa.',
    image: '/assets/160625_MARIAN_ELEMENTOSWEB_SLIDER_CLASICO.png',
    buttonText: 'Ver todos los productos',
    buttonLink: '/productos',
  },
  {
    customClass: 'banner-zaks',
    title: "Zak's®",
    description: "Combinamos mazapán, chocolate y galleta tipo wafer para crear el antojo más dulce y delicioso. Con Zak's® puedes darle la vuelta a tus momentos con un sabor increíble.",
    image: '/assets/160625_MARIAN_ELEMENTOSWEB_SLIDER_ZAKS.png',
    buttonText: 'Ver todos los productos',
    buttonLink: '/productos',
  },
  {
    customClass: 'banner-tartaletas',
    title: "Tartaletas",
    description: "Su base suave, y dulce centro de mermelada, es ideal para acompañar cualquier momento. Disfruta de una explosión de sabor, aroma y textura en cada mordida.",
    image: '/assets/160625_MARIAN_ELEMENTOSWEB_SLIDER_TARTALETAS.png',
    buttonText: 'Ver todos los productos',
    buttonLink: '/productos',
  },
  {
    customClass: 'banner-suspiros',
    title: "Suspiros",
    description: "Disfruta tus tardes y esos momentos especiales con Suspiros Marián®, una exquisita selección de galletas que enamoran al primer bocado. Delicadas, irresistibles y llenas de sabor… ¡robarán el corazón de todos los que las prueben!",
    image: '/assets/160625_MARIAN_ELEMENTOSWEB_SLIDER_SUSPIROS.png',
    buttonText: 'Ver todos los productos',
    buttonLink: '/productos',
  },
  {
    customClass: 'banner-nutret',
    title: "Nutret®",
    description: "Un snack práctico y ligero con ingredientes naturales que se adapta a tu ritmo de vida. Disfruta de sus 5 irresistibles variedades, una combinación perfecta de sabor y energía que puedes llevar a donde quieras. Ideal para darte ese impulso cuando más lo necesitas, mientras consientes a tu paladar.",
    image: '/assets/160625_MARIAN_ELEMENTOSWEB_SLIDER_NUTRET.png',
    buttonText: 'Ver todos los productos',
    buttonLink: '/productos',
  },
];

function Products() {

  return (
    <Box className="product-container">
      <Box
        className="product-title"
        sx={{
          height: "184px",
          backgroundColor: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          className="title-head"
          sx={{
            color: "#E66671",
            fontWeight: "bold",
            textAlign: "center",
            fontFamily: "BloodOrange, sans-serif",
          }}
        >
          ✧ Enamórate de nuestros productos ✧
        </Typography>
      </Box>
      <Box
        className="product-bg-container"
        sx={{
          position: "relative",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <BannerCarousel data={BannerData} />

      </Box>
    </Box>
  );
}

export default Products;